import React from "react";
import { Line } from "react-chartjs-2";
import ChartCard from "../ChartCard";
import { withLineChartStyles } from "../chartStyles";

const CheckinsChart = ({ checkinsChart }) => {
  return (
    <ChartCard chart={checkinsChart}>
      <Line
        data={withLineChartStyles(checkinsChart.data)}
        options={{
          responsive: true,
          maintainAspectRatio: false,
        }}
      />
    </ChartCard>
  );
};

export default CheckinsChart;
